export enum eStatusRequest {
    NONE = 'None',
    PROCESS = 'Process',
    ERROR = 'Error',
    ACCEPT = 'Accept',
    REJECT = 'Reject',
    EDIT = 'Edit',
    OMIT = 'Omit',
    WAIT = 'Wait',
    ASSIGN = 'Assign',
    CANCELLED = 'Cancelled',
    PRINTED = 'Printed',
    FINALIZED = 'Finalized'
}
